import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import BasicTable from '../../../../components/BasicTable';
import TableColumn from '../../../../components/BasicTable/TableColumn';
import TableHeaderButton from '../../../../components/BasicTable/TableHeaderButton';

import messages from './messages';
import staticStyles from './style';

interface MarketTableProps {
  sortName: string;
  setSortName: (value: string) => void;
  sortDesc: boolean;
  setSortDesc: (value: boolean) => void;
  children: ReactNode;
}

export default function MarketTable({
  sortName,
  setSortName,
  sortDesc,
  setSortDesc,
  children,
}: MarketTableProps) {
  const intl = useIntl();

  const borrowApyColumns = [
    {
      title: messages.variable,
      sortKey: 'variableBorrowRate',
    },
    {
      title: messages.stable,
      sortKey: 'stableBorrowRate',
    },
  ];

  return (
    <BasicTable
      className="MarketTable"
      headerColumns={
        <React.Fragment>
          <TableColumn className="MarketTable__header-column">
            <TableHeaderButton
              sortName={sortName}
              sortDesc={sortDesc}
              setSortName={setSortName}
              setSortDesc={setSortDesc}
              sortKey={'currencySymbol'}
              withSorting={true}
              title={intl.formatMessage(messages.assets)}
              subTitle={<>&nbsp;</>}
              subTitleBelow={true}
              size="small"
            />
          </TableColumn>
          <TableColumn className="MarketTable__header-column">
            <TableHeaderButton
              sortName={sortName}
              sortDesc={sortDesc}
              setSortName={setSortName}
              setSortDesc={setSortDesc}
              sortKey={'totalLiquidityInUSD'}
              withSorting={true}
              title={intl.formatMessage(messages.marketSize)}
              subTitle={intl.formatMessage(messages.availableForDeposit)}
              subTitleBelow={true}
              size="small"
            />
          </TableColumn>
          <TableColumn className="MarketTable__header-column">
            <TableHeaderButton
              sortName={sortName}
              sortDesc={sortDesc}
              setSortName={setSortName}
              setSortDesc={setSortDesc}
              sortKey={'totalBorrowsInUSD'}
              withSorting={true}
              title={intl.formatMessage(messages.totalBorrowed)}
              subTitle={intl.formatMessage(messages.availableToBorrow)}
              subTitleBelow={true}
              size="small"
            />
          </TableColumn>
          <TableColumn className="MarketTable__header-column">
            <TableHeaderButton
              sortName={sortName}
              sortDesc={sortDesc}
              setSortName={setSortName}
              setSortDesc={setSortDesc}
              sortKey={'depositAPY'}
              withSorting={true}
              title={intl.formatMessage(messages.depositAPY)}
              subTitle={<>&nbsp;</>}
              subTitleBelow={true}
              size="small"
            />
          </TableColumn>
          {borrowApyColumns.map((column, index) => (
            <TableColumn className="MarketTable__header-column" key={index}>
              <TableHeaderButton
                sortName={sortName}
                sortDesc={sortDesc}
                setSortName={setSortName}
                setSortDesc={setSortDesc}
                sortKey={column.sortKey}
                withSorting={true}
                title={intl.formatMessage(messages.borrowAPY)}
                subTitle={intl.formatMessage(column.title)}
                subTitleBelow={true}
                size="small"
              />
            </TableColumn>
          ))}
        </React.Fragment>
      }
    >
      {children}

      <style jsx={true} global={true}>
        {staticStyles}
      </style>
    </BasicTable>
  );
}
